export default "<h2 class=\"text-center\">\r\n    <a [href]=\"safeUrl\" target=\"_blank\">Click to View Terms and Conditions</a>\r\n</h2>";